import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import * as XLSX from "xlsx";
import MaterialTable from "material-table";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import Paper from "@material-ui/core/Paper";
import ClearOutlinedIcon from "@material-ui/icons/ClearOutlined";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import NavigateNextOutlinedIcon from "@material-ui/icons/NavigateNextOutlined";
import NavigateBeforeOutlinedIcon from "@material-ui/icons/NavigateBeforeOutlined";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { IconButton, Tooltip } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import EditIcon from '@mui/icons-material/Edit';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TextField from '@mui/material/TextField';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import LinearProgress from '@mui/material/LinearProgress';
import Checkbox from '@mui/material/Checkbox';
import StarIcon from '@mui/icons-material/Star';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListSubheader from '@mui/material/ListSubheader';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';

import InstructorCourseSettings from "./InstructorCourseSettings";
import AdminCourseFilters from "./AdminCourseFilters";

import {
	convertUnixToDate,
	filterCourses,
	createCustomFilter,
	getFilters,
	deleteFilter,
} from "../firebaseApi";
import { Typography } from "@material-ui/core";

const styles = (theme) => ({});

function AdminInterface(props) {
  let mobile = props.width === "sm" || props.width === "xs";

	const [displayCourse, setDisplayCourse] = React.useState(true);
	const [displayTerm, setDisplayTerm] = React.useState(true);
	const [displayInstructor, setDisplayInstructor] = React.useState(true);
	const [displayCreated, setDisplayCreated] = React.useState(false);
	const [displayArchived, setDisplayArchived] = React.useState(false);
	const [displayMarkedArchive, setDisplayMarkedArchive] = React.useState(false);
	const [displayAnonymous, setDisplayAnonymous] = React.useState(false);
	const [displayStudents, setDisplayStudents] = React.useState(false);
	const [displayTAs, setDisplayTAs] = React.useState(false);
	const [displaySessions, setDisplaySessions] = React.useState(true);
	const [displayPolls, setDisplayPolls] = React.useState(true);
	const [displayLastPoll, setDisplayLastPoll] = React.useState(false);
	const [displayStarred, setDisplayStarred] = React.useState(false);
	
	const [sortOrder, setSortOrder] = React.useState("ascend");
	const [sortBy, setSortBy] = React.useState("course");

	const [filterCourse, setFilterCourse] = React.useState("");
	const [filterInstructor, setFilterInstructor] = React.useState("");
	const [filterTerm, setFilterTerm] = React.useState("");
	const [filterCourseCreateBefore, setFilterCourseCreateBefore] = React.useState(null);
	const [filterCourseCreateAfter, setFilterCourseCreateAfter] = React.useState(null);
	const [filterStudentsLessThan, setFilterStudentsLessThan] = React.useState("");
	const [filterStudentsGreaterThan, setFilterStudentsGreaterThan] = React.useState("");
	const [filterLastPoll, setFilterLastPoll] = React.useState(null);
	const [filterAllCourses, setFilterAllCourses] = React.useState(false);
	const [filterActive, setFilterActive] = React.useState("both");
	const [filterStarred, setFilterStarred] = React.useState("both");
	const [loadingCourses, setLoadingCourses] = React.useState(false);

	const [customFilters, setCustomFilters] = React.useState({});
	const [savingFilter, setSavingFilter] = React.useState(false);
	const [openFilterEdit, setOpenFilterEdit] = React.useState(false);
	const [selFilterID, setSelFilterID] = React.useState("");

	const [settingsCourse, setSettingsCourse] = React.useState(null);
	const [openCourseSettings, setOpenCourseSettings] = React.useState(false);

	const [searchQuery, setSearchQuery] = React.useState("");
	const [tableData, setTableData] = React.useState([]);
	const [allCourseData, setAllCourseData] = React.useState({});
	const [filterError, setFilterError] = React.useState(false);

	React.useEffect(async() => {
		const myFilters = await getFilters({userEmail: props.account.accountEmail});
		setCustomFilters(myFilters);
	}, []);

	React.useEffect(() => {
		formatCourseData();
	}, [allCourseData]);

	const createCoursesCSV = () => {
		let headers = ["Course Name", "Term", "Instructor", "Created On", "Archived", 
			"Marked for Archiving", "Anonymous Course", "Total Students", "Total TAs", "Total Sessions",
			"Total Polls", "Last Poll", "Starred"];
		let csvData = [headers];
		tableData.filter(course => course.course.toLowerCase().includes(searchQuery.toLowerCase()) || course.instructor.toLowerCase().includes(searchQuery.toLowerCase()) || course.term.toLowerCase().includes(searchQuery.toLowerCase())).sort(sortCourses).forEach((course) => {
			let row = [course.course, course.term, course.instructor, 
				course.created ? convertUnixToDate(course.created) : "N/A", course.archived, 
				course.markedForArchive ? convertUnixToDate(course.markedForArchive) : "N/A", 
				course.anonymousCourse, course.totStudents, course.totTAs, course.totSessions, 
				course.totPolls, course.lastPoll ? convertUnixToDate(course.lastPoll) : "N/A", 
				course.starred];
			csvData.push(row);
		});
		let wb = XLSX.utils.book_new();
		let ws = XLSX.utils.aoa_to_sheet(csvData);
		let name = "Admin Interface Courses";
		XLSX.utils.book_append_sheet(wb, ws, name);
		XLSX.writeFile(wb, name + ".csv");
	}

	const filterSelected = (data) => {

		if (!data.filterAllCourses) {
			let setFilter = false;

			for (const [filterName, filterVal] of Object.entries(data)) {

				if (filterName !== "filterName" && filterName !== "filterActive" && filterName !== "filterStarred" && filterVal) {
					setFilter = true;
				}
			}
			return setFilter;
		} 
		return true;		
	}

	const saveNewFilter = async(data) => {
		setFilterError(false);

		if (!data.filterName) {
			setFilterError("No filter name");
			setSavingFilter(false);
			return;
		}

		if (!filterSelected(data)) {
			setFilterError("No filter selected");
			setSavingFilter(false);
			return;
		}
		data["filterID"] = selFilterID;
		data["userEmail"] = props.account.accountEmail;
		const filterID = await createCustomFilter(data);
		let newCustomFilters = {...customFilters};
		newCustomFilters[filterID] = data;
		setCustomFilters(newCustomFilters);
		setSavingFilter(false);
		setOpenFilterEdit(false);
	};

	const applyFilters = async(data) => {
		setFilterError(false);
		// const data = {
		// 	filterCourse: filterCourse,
		// 	filterInstructor: filterInstructor,
		// 	filterTerm: filterTerm,
		// 	filterCourseCreateAfter: filterCourseCreateAfter,
		// 	filterCourseCreateBefore: filterCourseCreateBefore,
		// 	filterStudentsLessThan: filterStudentsLessThan,
		// 	filterStudentsGreaterThan: filterStudentsGreaterThan,
		// 	filterLastPoll: filterLastPoll,
		// 	filterActive: filterActive,
		// 	filterStarred: filterStarred,
		// 	filterAllCourses: filterAllCourses,
		// };
		
		// if (!data.filterAllCourses) {
		// 	let setFilter = false;

		// 	for (const [filterName, filterVal] of Object.entries(data)) {

		// 		if (filterName !== "filterActive" && filterName !== "filterStarred" && filterVal) {
		// 			setFilter = true;
		// 		}
		// 	}
			
		if (!filterSelected(data)) {
			setFilterError("No filter selected");
			setLoadingCourses(false);
			return;
		}
		// } 

		const newCourseData = await filterCourses(data);
		setAllCourseData(newCourseData);
		setLoadingCourses(false);
	};

	const formatCourseData = () => {
		let formattedCourses = [];
		
		for (const [courseID, courseData] of Object.entries(allCourseData)) {
			const formattedCourse = {
				"id": courseID,
				"course": courseData.courseName,
				"term": courseData.courseTerm,
				"instructor": courseData.courseInstructorID,
				"created": courseData.courseCreated,
				"archived": !courseData.isActive,
				"markedForArchive": courseData.markedForArchive,
				"anonymousCourse": courseData.anonymousCourse,
				"totStudents": courseData.totStudents,
				"totTAs": courseData.tas.length,
				"totPolls": courseData.totPolls,
				"totSessions": courseData.totSessions,
				"lastPoll": courseData.lastPoll,
				"starred": courseData.starred,
			};
			formattedCourses.push(formattedCourse);
		}
		setTableData(formattedCourses);
	};

	const sortCourses = (first, second) => {
		let comp;
		switch(sortBy) {
			case "course": {
				comp = (first.course < second.course);
				break;
			}
			case "term": {
				comp = (first.term < second.term);
				break;
			}
			case "instructor": {
				comp = (first.instructor < second.instructor);
				break;
			}
			case "lastPoll": {
				comp = (Number(first.lastPoll) < Number(second.lastPoll));
			}
		}
		return (sortOrder === "ascend" ? (comp ? -1 : 1) : (comp ? 1 : -1));
	};

	const resetFilters = (resetAllCourses) => {
		setFilterCourse("");
		setFilterTerm("");
		setFilterInstructor("");
		setFilterCourseCreateAfter(null);
		setFilterCourseCreateBefore(null);
		setFilterStudentsLessThan("");
		setFilterStudentsGreaterThan("");
		setFilterLastPoll(null);
		setFilterActive("both");
		setFilterStarred("both");
		setFilterError(false);

		if (resetAllCourses) {
			setFilterAllCourses(false);
		}
	};

  return (
    <>
			<Dialog
				disableEscapeKeyDown
				disableEnforceFocus
				fullScreen={mobile}
				fullWidth
				maxWidth="xl"
				open={props.open}
				onClose={() => {
					props.openCtl(false);
				}}
			>
			<div style={{display: "flex", flexDirection: "row"}}>
			<DialogTitle>
				Admin Interface    
			</DialogTitle>
			<Tooltip 
				disabled={loadingCourses}
				title="Download Course Data"
				placement="bottom"
				style={{marginLeft: 5}}
			>
			<IconButton 
				size="medium"
				style={{
					marginLeft: "auto", 
					marginTop: "auto", 
					marginBottom: "auto", 
					marginRight: 23 
				}}
				onClick={() => {
					createCoursesCSV();
				}}
			>
				<DownloadIcon />
			</IconButton>
			</Tooltip>
			</div>
			<DialogContent>
					<div style={{ display: "flex", flexDirection: "row",  }}>
							<MaterialTable
									style={{width: "70%", marginLeft: "auto", marginRight: "auto" }}
									title=""
									columns={[
										{ title: "id", field: "id", hidden: true},
										{ title: "Course", field: "course", sorting: false, hidden: !displayCourse },
										{ title: "Term", field: "term", sorting: false, hidden: !displayTerm },
										{ title: "Instructor", field: "instructor", sorting: false, hidden: !displayInstructor },
										{ title: "Created On", field: "created", sorting: false, hidden: !displayCreated, render: rowData => rowData.created ? convertUnixToDate(rowData.created) : "N/A" },
										{ title: "Archived", field: "archived", sorting: false, hidden: !displayArchived, render: rowData => rowData.archived ? "Yes" : "No"},
										{ title: "Marked for Archiving", field: "markedForArchive", sorting: false, hidden: !displayMarkedArchive, render: rowData => rowData.markedForArchive ? convertUnixToDate(rowData.markedForArchive) : "N/A" },
										{ title: "Anonymous Course", field: "anonymousCourse", sorting: false, hidden: !displayAnonymous, render: rowData => rowData.anonymousCourse ? "Yes" : "No"},
										{ title: "Total Students", field: "totStudents", sorting: false, hidden: !displayStudents },
										{ title: "Total TAs", field: "totTAs", sorting: false, hidden: !displayTAs },
										{ title: "Total Sessions", field: "totSessions", sorting: false, hidden: !displaySessions },
										{ title: "Total Polls", field: "totPolls", sorting: false, hidden: !displayPolls },
										{ title: "Last Poll", field: "lastPoll", sorting: false, hidden: !displayLastPoll, render: rowData => rowData.lastPoll ? convertUnixToDate(rowData.lastPoll) : "N/A"},
										{ title: "Starred", field: "starred", sorting: false, hidden: !displayStarred, render: rowData => <StarIcon color={rowData.starred ? "primary" : "disabled"} />},
									]}
							  	data={tableData.filter(course => course.course.toLowerCase().includes(searchQuery.toLowerCase()) || course.instructor.toLowerCase().includes(searchQuery.toLowerCase()) || course.term.toLowerCase().includes(searchQuery.toLowerCase())).sort(sortCourses)}
									options={{
										actionsColumnIndex: -1,
										// search: false,
										toolbar: false,
									}}
									icons={{
										Clear: ClearOutlinedIcon,
										Search: SearchOutlinedIcon,
										NextPage: NavigateNextOutlinedIcon,
										PreviousPage: NavigateBeforeOutlinedIcon,
										ResetSearch: ClearOutlinedIcon,
										FirstPage: FirstPageIcon,
										LastPage: LastPageIcon,
									}}
									components={{
										Container: (props) => <Paper {...props} elevation={0} />,
									}}
									actions={[
										{
											icon: () => <InfoOutlinedIcon color="primary" />,
											tooltip: "All Course Info",
											onClick: (event, rowData) => {
												setSettingsCourse(rowData.id);
												setOpenCourseSettings(true);
											},
										},
										// {
										// 	icon: DownloadIcon,
										// 	isFreeAction: true,
										// 	tooltip: "Download Course Data",
										// 	onClick: () => {
										// 		console.log("Edit Info");
										// 	},
										// }
									]}
							/>
						<div style={{ width: "25%", }}>
							<FormControl fullWidth >
								
								<Input
									id="search-bar"
									placeholder="Search"
									value={searchQuery}
									onChange={(event)=> {
										setSearchQuery(event.target.value);
									}}
									startAdornment={
										<InputAdornment position="start">
											<SearchIcon />
										</InputAdornment>
          							}
									endAdornment={
										<IconButton 
											position="end"
											onClick={() => {
												setSearchQuery("");
											}}
										>
											<ClearIcon />
										</IconButton>
									}
								/>
							</FormControl>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
								>
									<Typography component="span">Display</Typography>
								</AccordionSummary>
								<AccordionDetails style={{ display: "flex", flexDirection: "column", }}>
									<FormControlLabel
										label="Course" 
										control={
											<Checkbox
												checked={displayCourse}
												onChange={(event) => {
													setDisplayCourse(event.target.checked);
												}}
											/>
										}
									/>
									<FormControlLabel
										label="Term" 
										control={
											<Checkbox
												checked={displayTerm}
												onChange={(event) => {
													setDisplayTerm(event.target.checked);
												}}
											/>
										}
									/>
									<FormControlLabel
										label="Instructor" 
										control={
											<Checkbox
												checked={displayInstructor}
												onChange={(event) => {
													setDisplayInstructor(event.target.checked);
												}}
											/>
										}
									/>
									<FormControlLabel
										label="Created On" 
										control={
											<Checkbox
												checked={displayCreated}
												onChange={(event) => {
													setDisplayCreated(event.target.checked);
												}}
											/>
										}
									/>
									<FormControlLabel
										label="Archived" 
										control={
											<Checkbox
												checked={displayArchived}
												onChange={(event) => {
													setDisplayArchived(event.target.checked);
												}}
											/>
										}
									/>
									<FormControlLabel
										label="Marked for Archiving" 
										control={
											<Checkbox
												checked={displayMarkedArchive}
												onChange={(event) => {
													setDisplayMarkedArchive(event.target.checked);
												}}
											/>
										}
									/>
									<FormControlLabel
										label="Anonymous Course" 
										control={
											<Checkbox
												checked={displayAnonymous}
												onChange={(event) => {
													setDisplayAnonymous(event.target.checked);
												}}
											/>
										}
									/>
									<FormControlLabel
										label="Total Students" 
										control={
											<Checkbox
												checked={displayStudents}
												onChange={(event) => {
													setDisplayStudents(event.target.checked);
												}}
											/>
										}
									/>
									<FormControlLabel
										label="Total TAs" 
										control={
											<Checkbox
												checked={displayTAs}
												onChange={(event) => {
													setDisplayTAs(event.target.checked);
												}}
											/>
										}
									/>
									<FormControlLabel
										label="Total Sessions" 
										control={
											<Checkbox
												checked={displaySessions}
												onChange={(event) => {
													setDisplaySessions(event.target.checked);
												}}
											/>
										}
									/>
									<FormControlLabel
										label="Total Polls" 
										control={
											<Checkbox
												checked={displayPolls}
												onChange={(event) => {
													setDisplayPolls(event.target.checked);
												}}
											/>
										}
									/>
									<FormControlLabel
										label="Last Poll" 
										control={
											<Checkbox
												checked={displayLastPoll}
												onChange={(event) => {
													setDisplayLastPoll(event.target.checked);
												}}
											/>
										}
									/>
									<FormControlLabel
										label="Starred" 
										control={
											<Checkbox
												checked={displayStarred}
												onChange={(event) => {
													setDisplayStarred(event.target.checked);
												}}
											/>
										}
									/>
								</AccordionDetails>
							</Accordion>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
								>
									<Typography component="span">Sort</Typography>
								</AccordionSummary>
								<AccordionDetails style={{ display: "flex", flexDirection: "column", gap: 20 }}>
									<FormControl>
										<FormLabel id="sort-label">Sort Order:</FormLabel>
										<RadioGroup
											aria-labelledby="sort-by"
											name="sort-group"
											value={sortOrder}
											onChange={(event) => {
												setSortOrder(event.target.value);
											}}
										>
											<FormControlLabel value="ascend" control={<Radio />} label="Ascending" />
											<FormControlLabel value="descend" control={<Radio />} label="Descending" />
										</RadioGroup>
									</FormControl>
									<FormControl >
										<FormLabel id="sort-label">Sort By:</FormLabel>
										<RadioGroup
											aria-labelledby="sort-by"
											name="sort-group"
											value={sortBy}
											onChange={(event) => {
												setSortBy(event.target.value);
											}}
										>
											<FormControlLabel value="course" control={<Radio />} label="Course Name" />
											<FormControlLabel value="term" control={<Radio />} label="Term" />
											<FormControlLabel value="instructor" control={<Radio />} label="Instructor" />
											<FormControlLabel value="lastPoll" control={<Radio />} label="Last Poll" />
											
										</RadioGroup>
									</FormControl>
								</AccordionDetails>
							</Accordion>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
								>
									<Typography component="span">Filter</Typography>
								</AccordionSummary>
								<AccordionDetails style={{display: "flex", flexDirection: "column", gap: 15, }}>
									<AdminCourseFilters 
										view={"apply"}
										error={filterError}
										loading={loadingCourses}
										customFilters={customFilters}
										openFilterEdit={(open) => {
											setOpenFilterEdit(open);
										}}
										setError={(error) => {
											setFilterError(error);
										}}
										applyFilters={(data) => {
											setLoadingCourses(true);
											applyFilters(data);
										}}
									/>
									{/* <FormControlLabel
										label="Show All Courses" 
										control={
											<Checkbox
												checked={filterAllCourses}
												onChange={(event) => {
													setFilterAllCourses(event.target.checked);
													resetFilters(false);
												}}
											/>
										}
									/>
									<TextField 
										id="course" 
										label="Course" 
										disabled={filterAllCourses}
										variant="outlined" 
										value={filterCourse}
										onChange={(event) => {
											setFilterCourse(event.target.value);
										}}
									/>
									<TextField 
										id="instructor" 
										label="Instructor" 
										disabled={filterAllCourses}
										variant="outlined" 
										value={filterInstructor}
										onChange={(event) => {
											setFilterInstructor(event.target.value);
										}}
									/>
									<TextField 
										id="term" 
										label="Term" 
										disabled={filterAllCourses}
										variant="outlined" 
										value={filterTerm}
										onChange={(event) => {
											setFilterTerm(event.target.value);
										}}
									/>
									<TextField
										variant="outlined"
										label="Tot. Students Less Than"
										disabled={filterAllCourses}
										value={filterStudentsLessThan}
										onChange={(event) => {
		
											if (!isNaN(+event.target.value) || event.target.value === "") {
												setFilterStudentsLessThan(event.target.value);
											}
										}}
									/>
									<TextField
										variant="outlined"
										label="Tot. Students Greater Than"
										disabled={filterAllCourses}
										value={filterStudentsGreaterThan}
										onChange={(event) => {
		
											if (!isNaN(+event.target.value) || event.target.value === "") {
												setFilterStudentsGreaterThan(event.target.value);
											}
										}}
									/>
									<DatePicker
										disabled={filterAllCourses}
										label="Course Created Before"
										value={filterCourseCreateBefore}
										onChange={(newValue) => {
												setFilterCourseCreateBefore(newValue === null? newValue: newValue.valueOf());
										}}
										renderInput={(params) => <TextField {...params} />}
									/>
									<DatePicker
										disabled={filterAllCourses}
										label="Course Created After"
										value={filterCourseCreateAfter}
										onChange={(newValue) => {
											setFilterCourseCreateAfter(newValue === null ? newValue : newValue.valueOf());
										}}
										renderInput={(params) => <TextField {...params} />}
									/>
									<DatePicker
										disabled={filterAllCourses}
										label="Last Poll Before"
										value={filterLastPoll}
										onChange={(newValue) => {
											setFilterLastPoll(newValue === null ? newValue : newValue.valueOf());
										}}
										renderInput={(params) => <TextField {...params}  />}
									/>
									<FormControl>
										<InputLabel id="filterActiveLabel">Active Courses</InputLabel>
										<Select
											displayEmpty
											labelId="filterActiveLabel"
											disabled={filterAllCourses}
											id="filterActive"
											value={filterActive}
											label="Active Courses"
											onChange={(event) => {
												setFilterActive(event.target.value);
											}}
										>
											<MenuItem value={"both"}>Include Active and Inactive</MenuItem>
											<MenuItem value={"active"}>Only Include Active</MenuItem>
											<MenuItem value={"inactive"}>Only Include Inactive</MenuItem>
										</Select>
									</FormControl>
									<FormControl>
										<InputLabel id="filterStarredLabel">Starred Courses</InputLabel>
										<Select
											displayEmpty
											labelId="filterStarredLabel"
											disabled={filterAllCourses}
											id="filterStarred"
											value={filterStarred}
											label="Starred Courses"
											onChange={(event) => {
												setFilterStarred(event.target.value);
											}}
										>
											<MenuItem value={"both"}>Include Starred and Unstarred</MenuItem>
											<MenuItem value={"starred"}>Only Include Starred</MenuItem>
											<MenuItem value={"unstarred"}>Only Include Unstarred</MenuItem>
										</Select>
									</FormControl>
									{noFilterError && <Typography color="error">No filters selected</Typography>}
									<div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
									<Button 
										variant="text" 
										color="primary"
										style={{ display: loadingCourses ? "none" : "block"}}
										onClick={() => {
											setLoadingCourses(true);
											applyFilters();
										}}
									>
										Apply
									</Button>
									<Button 
										variant="text" 
										color="primary"
										style={{ display: loadingCourses ? "none" : "block"}}
										onClick={() => {
											resetFilters(true);
										}}
									>
										Clear
									</Button>
									</div>
									<LinearProgress style={{display: loadingCourses ? "block" : "none" }} /> */}
								</AccordionDetails>
							</Accordion>	
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
								>
									<Typography component="span">Custom</Typography>
								</AccordionSummary>
								<AccordionDetails style={{display: "flex", flexDirection: "column", gap: 15, }}>
									{openFilterEdit ? 
										<AdminCourseFilters 
											key={openFilterEdit}
											view={"edit"}
											error={filterError}
											selFilter={customFilters[selFilterID]}
											loading={savingFilter}
											openFilterEdit={(open) => {
												setOpenFilterEdit(open);
											}}
											setError={(error) => {
												setFilterError(error);
											}}
											applyFilters={(data) => {
												setSavingFilter(true);
												console.log(data);
												saveNewFilter(data);
											}}
											deleteFilter={() => {
												setLoadingCourses(true);
												deleteFilter({filterID: selFilterID, userEmail: props.account.accountEmail});
												let newCustomFilters = {...customFilters};
												delete newCustomFilters[selFilterID];
												setCustomFilters(newCustomFilters);
												setLoadingCourses(false);
												setOpenFilterEdit(false);
											}}
										/>
										: 
										<div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
											<Typography variant="subtitle1" style={{color: "#616161"}}>Custom Filters:</Typography>
											<List
												disablePadding
												style={{px: 0,}}
												// subheader={<ListSubheader disableGutters style={{px:0}}>Custom Filters:</ListSubheader>}
											>
												{/* <ListSubheader style={{backgroundColor: "red", margin: 0}}>Custom Filters:</ListSubheader> */}
												{Object.entries(customFilters).map(([filterID, filter]) => 
													<ListItem 
														key={filterID} 
														secondaryAction={
															<IconButton 
																edge="end"
																onClick={() => {
																console.log(filterID);
																console.log(customFilters[filterID]);
																setSelFilterID(filterID);
																setOpenFilterEdit(true);
															}}
															>
																<EditIcon />
															</IconButton>
														}
													>
														{/* <ListItemButton
															// disableGutters
															onClick={() => {
																console.log(filterID);
																console.log(customFilters[filterID]);
																setSelFilterID(filterID);
																setOpenFilterEdit(true);
															}}
														> */}
															<ListItemText primary={filter.filterName} />
														{/* </ListItemButton> */}
													</ListItem>
												)}
											</List>
											<Button 
												variant="text" 
												color="primary"
												onClick={() => {
													setOpenFilterEdit(true);
												}}
											>
												New Filter
											</Button>
										</div>
									}
								</AccordionDetails>
							</Accordion>
						</div>
					</div>
				</DialogContent>
				<DialogActions>
					<Button
						color="primary"
						onClick={() => {
							props.openCtl(false);
						}}
					>
						Close
					</Button>
				</DialogActions>
			</Dialog>
			<InstructorCourseSettings 
				key={"Settings New" + openCourseSettings}
				adminView={true}
				open={openCourseSettings}
				openCtl={(open) => {
					setOpenCourseSettings(open);
				}}
				newCourse={false}
				course={allCourseData[settingsCourse]}
				updateCourse={(data) => {
					let newCourses = {...allCourseData};
					newCourses[settingsCourse]["starred"] = data.starred;
					newCourses[settingsCourse]["markedForArchive"] = data.markedForArchive;
					newCourses[settingsCourse]["isActive"] = data.isActive;
					newCourses[settingsCourse]["maxTAs"] = data.maxTAs;
					newCourses[settingsCourse]["notifyArchive"] = data.notifyArchive;
					setAllCourseData(newCourses);
				}}
			/>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    account: state.account,
	}
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(
      withWidth()(AdminInterface)
    )
  )
);
